// Buyer file-request → real (hidden) file. When an agent requests a file for a
// buyer lead, we mint a hidden `dealtype:"Buyer"` / `requestType:"fileRequest"`
// / `dealStage:"CMAs"` deal (auto-hidden from the Deals Board) so the buyer gets
// a Drive folder (for the signed buyer agreement) and becomes eligible for the
// client-portal buyer forms. The buyer still lives in the Buyers Pipeline; the
// lead is linked to the file by `sourceDealId` so Convert-to-Deal reuses it
// instead of creating a duplicate. See
// docs/superpowers/specs/2026-07-14-pre-deploy-file-folder-improvements-design.md
import {
  createFileRequestFromLead,
  updateBuyerLead,
} from "./firebasefunctions";

// Idempotent: if the lead already links a file (sourceDealId), don't create a
// second one — just (re)flag the lead so the pipeline badge is correct.
export async function requestBuyerFile(
  lead,
  user = {},
  { sendForms = false, details = {} } = {},
) {
  if (lead?.sourceDealId) {
    await updateBuyerLead(lead.id, {
      fileRequested: true,
      fileRequestedAt: Date.now(),
    });
    return {
      deal: { createdat: Number(lead.sourceDealId), id: String(lead.sourceDealId) },
      reused: true,
      sendForms,
    };
  }

  // The request dialog's answers (file format, deadline, …) ride along so the
  // team gets a complete request. See utils/fileRequestDetails.js.
  const { deal } = await createFileRequestFromLead(lead, "buyer", user, details);
  const linkRes = await updateBuyerLead(lead.id, {
    fileRequested: true,
    fileRequestedAt: Date.now(),
    sourceDealId: String(deal.createdat),
  });
  // updateBuyerLead resolves {success:false} instead of throwing. An unlinked
  // lead would later re-prompt for a second file and graduate a bare deal, so
  // surface it (the caller shows this message).
  if (linkRes?.success === false) {
    throw new Error(
      "File created, but it couldn't be tied to the pipeline lead. Open the lead and check before requesting again.",
    );
  }
  return { deal, reused: false, sendForms };
}
